import React from 'react';
import {connect} from 'react-redux';
import {defineMessages, FormattedMessage} from 'react-intl';

import * as BetTypeMap from 'constants/BetType';
import BetSlipList from './BetSlipList.jsx';
import Controls from './Controls.jsx';
import UnauthControls from './UnauthControls.jsx';
import ControlsExt from './ControlsExt.jsx';
import UnauthControlsExt from './UnauthControlsExt.jsx';

import {removeCouponRates as removeCouponRatesAction} from 'actions/creators/CouponRate';

const messages = defineMessages({
    newBet: {
        id: 'coupon.title',
        defaultMessage: 'Новая ставка'
    }
});

class Coupon extends React.Component {

    constructor(props) {
        super(props);

        this._onClearClick = this._onClearClick.bind(this);
    }

    _onClearClick(e) {
        e.preventDefault();
        this.props.removeCouponRatesAction();
    }

    render() {
        const {betSlips, currentBetTypeIndex, betTypes, user} = this.props;
        if (betSlips === undefined || betSlips.size === 0) {
            return false;
        }

        const betType = betTypes.get(currentBetTypeIndex);
        const isMultiSingleSlip = (betSlips.size > 1 && (betType || {}).type === BetTypeMap.SINGLE);

        return (
            <div className="body coupon-body cf">
                <div className="title">
                    <FormattedMessage {...messages.newBet} />
                    <a href="#" className="close" onClick={this._onClearClick}>{'\u00A0'}</a>
                </div>
                <BetSlipList onUpdateSize={this.props.onUpdateSize}/>
                {(user && !isMultiSingleSlip) && <Controls/>}
                {(user && isMultiSingleSlip) && <ControlsExt/>}
                {(!user && !isMultiSingleSlip) && <UnauthControls/>}
                {(!user && isMultiSingleSlip) && <UnauthControlsExt/>}
            </div>
        );
    }
}

Coupon.propTypes = {
    betSlips: React.PropTypes.object.isRequired,
    currentBetTypeIndex: React.PropTypes.number.isRequired,
    betTypes: React.PropTypes.object.isRequired,
    user: React.PropTypes.any,
    removeCouponRatesAction: React.PropTypes.func.isRequired,
    onUpdateSize: React.PropTypes.func.isRequired
};

function select(state) {
    const betSlips = state.application.getIn(['coupon', 'betSlips']);
    const currentBetTypeIndex = state.application.getIn(['coupon', 'currentBetTypeIndex']);
    const betTypes = state.application.getIn(['coupon', 'betTypes']);
    const user = state.auth.get('user');
    const languageId = state.application.get('languageId');

    return {
        betSlips,
        currentBetTypeIndex,
        betTypes,
        user,
        languageId
    };
}

export default connect(select, {removeCouponRatesAction})(Coupon);


// WEBPACK FOOTER //
// ./js/sport-betting/components/bet-panel-control/coupon/Coupon.jsx